import React from "react";
import { AlertStripeAdvarsel } from "nav-frontend-alertstriper";

export const OutageNotice = () => (
  <AlertStripeAdvarsel>
    GoGift har for tiden tekniske problemer.
    <br />
    Send en e-post til{" "}
    <a href="mailto:elin.svensen@uis.no">elin.svensen@uis.no</a>, så får du
    beskjed når problemene er løst og du kan hente gavekortet i appen.
    <br />
    <br />
    Har du allerede fått utdelt gavekort tidligere? Da kan du fortsatt logge inn
    for å hente det ut.
  </AlertStripeAdvarsel>
);
